import React, { Component } from 'react';
import Container from '../../components/Container';
import { Grid,List, ListItem,ListItemIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import CustomTypo from '../../components/CustomTypo';
import DrawerCustom from '../../components/DrawerCustom';
import { getAppCfg } from '../../utils/common';
import { PrivacyIcon, MailWhiteIcon, TermConditionIcon, FAQIcon, MoreInfoIcon } from '../../components/icons';


const styles = theme => ({
    icon: {
        backgroundColor:'rgba(255,255,255,0.1)',
        borderRadius: theme.spacing(8),
        padding: theme.spacing(2),
    },
    listItem: {
        padding: theme.spacing(4),
    },
});
function MoreInfoView(props){
    const getIcon = (icon, classes) =>{
        var MyIcon = icon;
        return <MyIcon className={classes} />
    }
    const {classes, t, onClickItem } = props
    const app_config = getAppCfg();
    var about_details = app_config && app_config.about_details ? app_config && app_config.about_details: {}
    const moreInfoConfig = [
        { title: 'privacy_title', icon: PrivacyIcon, id: 'privacy', showMenu: true, url: about_details.privacy_policy && about_details.privacy_policy.url?about_details.privacy_policy.url : null },
        { title: 'about_title', icon: MoreInfoIcon, id: 'about', showMenu: true, url: about_details.about && about_details.about.url?about_details.about.url : null  },
        { title: 'contact_us_title', icon: MailWhiteIcon, id: 'contact_us', showMenu: true, url:  about_details.contact_us && about_details.contact_us.url?about_details.contact_us.url : null  },
        { title: 'faq_title', icon: FAQIcon, id: 'faq', showMenu: true, url: about_details.faqs && about_details.faqs.url?about_details.faqs.url : null  },
        { title: 'term_condition_title', icon: TermConditionIcon, id: 'term_conditions', showMenu: true, url: about_details.terms_conditions && about_details.terms_conditions.url?about_details.terms_conditions.url : null  },
    ]
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={()=>props.handleDrawerOtherToggle('more_info')}
                title = {t('more_info')}
                children={        
                    <Grid item >
                        <List>
                            {moreInfoConfig.map((item, index) => item.showMenu ? (
                                <ListItem button key={index} className={ classes.listItem} onClick={() => onClickItem(item)}>
                                    <ListItemIcon>{getIcon(item.icon, classes.icon)}</ListItemIcon>
                                    <CustomTypo variant='subtitle1' color='onPrimary' >{t(item.title)}</CustomTypo>
                                </ListItem>
                            ) : null)}
                        </List>
                </Grid>}/>
    </div>
    );
}
export default withStyles(styles)(withTranslation()(MoreInfoView));